<template>

  <v-dialog persistent scrollable width="580px" v-model="dialog" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title>
        <app-title> {{ title }} </app-title>
        <app-delete-btn v-if="!isInsert" @click="handleDelete()" x-small class="ml-auto" type="icon" />
      </v-card-title>

      <v-card-text class="pt-1">
        <v-row>
          <v-col>
            <app-text-field v-model="form.name" label="Nome" outlined />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <app-back-btn @click="dialog = false" />
        <v-spacer v-if="$vuetify.breakpoint.xsOnly" />
        <app-confirm-btn @click="handleSave()" />
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      form: {},
      baseForm: {
        name: null,
        status: "active",
      },
    };
  },
  computed: {
    isInsert() {
      return !this.form.id;
    },
    title() {
      if (this.isInsert) {
        return "Novo Grupo";
      }
      if (!this.isInsert) {
        return "Editar Grupo";
      }
    },
  },

  created() {
    this.reset();
  },

  methods: {
    open(id = null) {
      this.reset();
      if (id) {
        this.showGroup(id);
      }
      this.dialog = true;
    },

    reset() {
      this.form = JSON.parse(JSON.stringify(this.baseForm));
    },

    async showGroup(id) {
      this.$loading.start();

      await this.$http.show("group/group", id).then((response) => {
        this.form = response.group;
        this.$loading.finish();
      }).catch((error) => {
        this.$loading.finish();
      });
    },

    handleSave() {
      if (this.isInsert) {
        this.store();
      } else {
        this.update();
      }
    },

    store() {
      this.$loading.start();

      return this.$http.store("group/group", this.form).then((response) => {
        this.processSaved(response.group);
        this.$loading.finish();
      }).catch((error) => {
        this.$loading.finish();
      });
    },

    update() {
      this.$loading.start();

      return this.$http
        .update("group/group", this.form.id, this.form)
        .then((response) => {
          console.log(response);
          this.processSaved();
          this.$loading.finish();
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
    handleDelete() {
      this.$loading.start();
      this.$http
        .destroy("group/group", this.form.id)
        .then((response) => {
          this.processSaved();
          this.$loading.finish();
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },

    processSaved(group) {
      this.$emit("store", group);
      this.dialog = false;
    },
  },
};
</script>

<style></style>